
import Loading from 'vux/src/components/loading/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import {loginGetAu} from 'api/evaluation'
import myStep from '@/components/baseComponents/MyStep'
export default {
components: {
Loading,
XButton,
XInput,
myStep
},
data () {
return {
loading: false,
text: '加载中',
step1: 1,
formData: {
loginName: '15281018761',
authCode: '12',
password: 'smqy123',
userType: 'USER_TYPE_PERSONAL'
},
au: ''
}
},
created () {
this.loading = this.isDev
if (this.isDev) {
this.getAu()
}
},
methods: {
getAu () {
let vm = this
loginGetAu(this.formData, '').then((res) => {
if (res.code === 0) {
this.au = res.data.bean.au
vm.$vux.toast.show({type: 'success', text: '登录成功'})
} else {
vm.$vux.toast.show({type: 'warn', text: res.msg})
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Index.vue